const PRECHAT_FIELDS_KEY = "embeddedservice_bootstrap_prechatFields";

const getCookieValue = (name) => {
    if (typeof document === "undefined") {
        return undefined;
    }

    return document.cookie
        ?.split("; ")
        ?.find((cookie) => cookie.startsWith(`${name}=`))
        ?.split("=")[1];
};

const readSessionStorageJson = (key) => {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) {
        return {};
    }

    try {
        return JSON.parse(raw);
    } catch {
        return {};
    }
};

const getSalesforceChatPageName = (pathname = "") => {
    if (window.location.pathname.includes("profile-ui")) {
        return "My Profile";
    }

    return null;
};

export const updateSalesforceChatPrechatFields = (pathname) => {
    if (!window.location.host.includes("myaccount")) {
        return;
    }

    const loginCookie = getCookieValue("mySLogin");
    const isLoggedIn = loginCookie?.toLowerCase() === "loggedin";
    if (!isLoggedIn) {
        return;
    }

    const isChatEnabledFlag =
        window.sessionStorage.getItem("showSalesforceChat") === "true";
    if (!isChatEnabledFlag) {
        return;
    }

    const pageName = getSalesforceChatPageName(
        pathname || window.location.pathname
    );

    if (!pageName) {
        return;
    }

    const prechatFields = readSessionStorageJson(PRECHAT_FIELDS_KEY);
    window.sessionStorage.setItem(
        PRECHAT_FIELDS_KEY,
        JSON.stringify({
            ...prechatFields,
            pageName
        })
    );
};
